import React from 'react';
import PageContainer from '../../components/global/PageContainer';
import { withAuthorization, withOrganization } from '../../components/Session';
import AddAudioForm from '../../components/AddAudioForm';
import { withFirebase } from '../../components/Firebase';

const EditAudio = props => {
  const {
    match: { params },
  } = props;

  return (
    <PageContainer>
      <AddAudioForm trackId={params.trackId} firebase={props.firebase} />
    </PageContainer>
  );
};

const condition = authUser => !!authUser;
export default withOrganization(withAuthorization(condition)(withFirebase(EditAudio)));
